//import logo from "../../assets/logo.png";
import styles from "./header.module.scss";
import UserMenu from "./UserMenu";
import logo from "./../../assets/logo-alt.png";

const Header = () => {
  return (
    <>
      <div className={`${styles.header} container-fluid`}>
        <div className="row align-items-center h-100">
          <div className="col-3 col-md-3">
            <a href="https://climate.bot" className={`${styles.link}`}>
              <img src={logo} alt="Logo"/>
            </a>
          </div>
          <div className="col-md-6 d-md-flex d-none" />
          <div className="col-9 col-md-3 d-flex justify-content-end">
            <UserMenu />
          </div>
        </div>
      </div>
      <div className={`${styles.glow}`}/>
    </>
  );
};
export default Header;
